import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import LocationsFile from '../Resources/Example of Locations.csv';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import LocationService from '../Services/LocationService/location';
import { css } from 'react-emotion';
import {  Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
import './stylesInputFile.css'
var base64 = require('base-64');


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}
class LocationsImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            LocationList: { pennding: false, value: [] },
            LocationUpList: { pennding: false, value: [] },
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            TimeZoneValidation: "",
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HLocationCode: false,
            HLocationName: false,
            HTimeZone: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleHLocationCode = this.handleHLocationCode.bind(this);
        this.handleHLocationName = this.handleHLocationName.bind(this);
        this.handleHTimeZone = this.handleHTimeZone.bind(this);
    }
    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ?  e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            LocationUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });             
        if(uploadedFile){
            if(extFile.toUpperCase() !== "CSV")
            {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
        let reader = new FileReader();    
        reader.onload = (progressEvent) => {
            // let target = progressEvent.target; 
            // let result = target.result;               
            var base64result = reader.result.split(',')[1];
            var encoded = base64.decode(base64result);
            var data = encoded.split('\n');
            var DataList = [];
            data.forEach(element => {
                DataList.push(element.split(','));                
            });
            //console.log(DataList)

            var LocationName = "";
            var LocationCode = "";
            var TimeZone ="";
            DataList[0].forEach(function(element) {

                if(element.replace(/\s/g, "").toUpperCase() === "LOCATIONCODE"){
                    
                    LocationCode = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "LOCATIONNAME"){

                    LocationName = element;
                }else if(element.replace(/\s/g, "").toUpperCase() === "TIMEZONE"){

                    TimeZone = element;
                }
              });
            this.setState({
                LocationUpList: { pennding: true, value: DataList},
                HeadersList: DataList[0],
                Headers: true,
                UploadFileName: name,
                HLocationName: { value: LocationName , label: LocationName},
                HLocationCode: { value: LocationCode , label: LocationCode},
                HTimeZone: { value: TimeZone , label: TimeZone}
            });    
          };    
          reader.readAsDataURL(uploadedFile); 
        }else{
            this.setState({
                EmployeeUpList: { pennding: true, value: []},
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });   
        } 
    }
    handleChange = event => {
        this.setState({
            selectedValue: event.target.value,
            LocationList: { pennding: false, value: [] }
        });
    }
    handleHLocationCode = event => {
        this.setState({
            HLocationCode: event
        });
    }
    handleHLocationName = event => {
        this.setState({
            HLocationName: event
        });
    }
    handleHTimeZone = event => {
        this.setState({
            HTimeZone: event
        });
    }
    onChange(e, code) {
        const options = this.state.checkboxOptions
        let index;
        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {
        //console.log(e.target.checked)
        if (e.target.checked) {
            let optionChecked = [];
            this.state.LocationList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.COMPANY_LOCATION_CODE);
            })
            this.setState({ checkboxOptions: optionChecked })
        }
        else {
            this.setState({ checkboxOptions: [] })
        }
    }
    UploadLocationList(e){
        e.preventDefault();
        var ActionType = this.state.selectedValue;
        var DataList = this.state.LocationUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderLocationCode = this.state.HLocationCode.value;
        var HeaderLocationName = this.state.HLocationName.value;
        var HeaderTimeZone = this.state.HTimeZone.value;
        var Result = [];
        var positionLocationCode = HeaderListist.indexOf(HeaderLocationCode);
        var positionLocationName = HeaderListist.indexOf(HeaderLocationName);
        var positionTimeZone = HeaderListist.indexOf(HeaderTimeZone);

        if(positionLocationCode === -1)
        {
            toast.error("Location Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if(positionLocationName === -1)
        {
            toast.error("Location Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }       
        var TimeZone = ""; 
        for(var i= 1; i< (DataList.length -1); i++)
        { 
            if(DataList[i] !== "")
            {
                if(positionTimeZone === -1)
                  TimeZone = "";
                else
                  TimeZone =  DataList[i][positionTimeZone];          

               Result.push({ COMPANY_LOCATION_CODE: DataList[i][positionLocationCode], COMPANY_LOCATION_NAME: DataList[i][positionLocationName], TIME_ZONE_ID: TimeZone });
            }        
        }

        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {
            if (this.props.CompanyCode && DataList) {
                this.setState({
                    LocationList: { pennding: true, value: [] }
                });
                var ListResult = LocationService.getListResult(this.props.CompanyCode, Result, ActionType);
                var that = this;
                ListResult.then(function (data) {
                    if (data.status === 200) {
                        that.setState({
                            LocationList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    }
                }).catch((error) => {
                    that.setState({
                        LocationList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if(error.response)
                    {
                        if(error && error.response && error.response.data.Message === "500") {               
                            toast.error("Error Data Base(Error: 500)", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NoDB") {
                           toast.error("Company Code dosen't exist!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data === "NotReseller") {    
                           toast.error("This User does not have permission!", { className: {
                               opacity: 0.8
                           }});
                       }else if(error && error.response && error.response.data.Message === "400"){ 
                           toast.error("API Error for Reseller", { className: {
                               opacity: 0.8
                           }});
                        }else if(error.response.status === 401){ 
                               sessionStorage.setItem("user", '');
                               sessionStorage.setItem("token", '');
                               sessionStorage.setItem("rol", '');
                               sessionStorage.setItem("email", '');
                               sessionStorage.clear();  
                               this.setState({ isAutenticated: false },
                               ()=>{                               
                                   this.forceUpdate();
                               })              
                        }   
                    }else{
                        toast.error("Code Error", { className: {
                            opacity: 0.8
                        }});
                    }
                });
            }
        }
    }
    SaveLocationList(e) {
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions;
        var result = [];
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var that = this;
        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a location and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var location = this.state.LocationList.value.find(x => x.COMPANY_LOCATION_CODE === l);
                result.push(location);
            });
            var DataResult = LocationService.SaveLocation(this.props.CompanyCode, result, ActionType, email);
            DataResult.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        loading: false,
                        LocationList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.success("Locations Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }else if (data.data === "InUse") {
                    that.setState({
                        loading: false,
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("Locations Code in Use!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }else if (data.statusText === "AuditError") {
                    that.setState({
                        loading: false,
                        LocationList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("Audit Error!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }else if (data.statusText === "No") {
                    that.setState({
                        loading: false,
                        LocationList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            }).catch((error) => {
                that.setState({
                    loading: false,
                    LocationList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: "",
                });
                if(error.response)
                {
                    if(error && error.response && error.response.data.Message === "500") {               
                        toast.error("Error Data Base(Error: 500)", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NoDB") {
                       toast.error("Company Code dosen't exist!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NotReseller") {    
                       toast.error("This User does not have permission!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data.Message === "400"){ 
                       toast.error("API Error for Reseller", { className: {
                           opacity: 0.8
                       }});
                    }else if(error.response.status === 401){ 
                           sessionStorage.setItem("user", '');
                           sessionStorage.setItem("token", '');
                           sessionStorage.setItem("rol", '');
                           sessionStorage.setItem("email", '');
                           sessionStorage.clear();  
                           this.setState({ isAutenticated: false },
                           ()=>{                               
                               this.forceUpdate();
                           })              
                    }   
                }else{
                    toast.error("Code Error", { className: {
                        opacity: 0.8
                    }});
                }
            });
        }
    }
    changeName(e) {
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)

        var extention = res.split('.').pop();

        if (extention.toUpperCase() === "CSV") {
            this.setState({
                FileName: res
            });
        } else {
            this.setState({
                FileName: "CHOOSE A FILE",
                LocationUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        return true;
    }

    render() {
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        let optionItemsHeaders = this.state.HeadersList.map((item, index) => { 
            return {value: item, label: item}
        });
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Locations</span></h4>
                            </div>                   
                            <div className="col-2 offset-10">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={LocationsFile} download="Example of Locations.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 offset-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={Math.random()*1200000}>
                                        <button style={{ 'width' : '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px'}} onClick={(e)=>this.fileInput.click(e)}  className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input  ref={input =>this.fileInput = input } type="file" name="myfile" style={{'display': 'none'}}  onChange={ (event)=>{this.handleData(event)}}/>                                   
                                    </div>
                                }
                            </div>
                            <div className="col-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Delete Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '1'}
                                            onChange={this.handleChange}
                                            value="1"
                                            name="radio-button-demo"
                                            aria-label="A"
                                            color="primary"
                                        />
                                    </div>
                                }

                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Appends Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '2'}
                                            onChange={this.handleChange}
                                            value="2"
                                            name="radio-button-demo"
                                            aria-label="B"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <br /> <br />
                        {
                                this.state.Headers
                                &&
                                <div className="row">                               
                                        <div className="col-2 offset-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Location Code(<span style={{color: 'red'}}>*</span>):</label>
                                                <Select
                                                    value={this.state.HLocationCode}
                                                    onChange={this.handleHLocationCode}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block"}} >Location Name(<span style={{color: 'red'}}>*</span>):</label>
                                                <Select
                                                    value={this.state.HLocationName}
                                                    onChange={this.handleHLocationName}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                        </div>   
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block"}} >Time Zone</label>
                                                <Select
                                                    value={this.state.HTimeZone}
                                                    onChange={this.handleHTimeZone}
                                                    options={optionItemsHeaders}
                                                    styles={{  width: "10px"}}
                                                />
                                            </div>
                                        </div>   
                                        <div className="col-2 offset-2" style={{ paddingTop: '28px'}}>
                                            <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >PREVIEW</button>
                                        </div>                             
                                </div>
                          }   
                    </div>
                </div>
                {
                    (this.state.LocationList.pennding
                        && <span className="loader"></span>)
                    ||
                    (this.state.LocationList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body">
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto' }}>
                                    <table className="table table-hover table-striped table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                <th scope="col">Location Code</th>
                                                <th scope="col">Location Name</th>
                                                <th scope="col">Time Zone</th>
                                            </tr>
                                        </thead>
                                        <tbody style={scrollTable}>
                                            {
                                                (this.state.LocationList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.LocationList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.COMPANY_LOCATION_CODE) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.COMPANY_LOCATION_CODE)}
                                                                        value={item.COMPANY_LOCATION_CODE}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                            }

                                                        </td>
                                                        <td>{item.COMPANY_LOCATION_CODE}</td>
                                                        <td>{item.COMPANY_LOCATION_NAME}</td>
                                                        <td>{item.TIME_ZONE_ID}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SaveLocationList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}

export default LocationsImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/LocationsImportFile.jsx